module.exports = __webpack_public_path__ + "static/media/galileu_azul.a83399cd.png";